module.exports = __webpack_public_path__ + "img/genshin.e99161a.jpg";